import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
import {setAuthToken} from '../helpers/authHelper';
import { USER_HASH_EXPIRED, FETCH_USER_OBJECT, FETCH_USER_IDENTITY_DATA } from '../actions/userDataActions';

export function fetchUserInformation(uuid){
  return dispatch => {
    return axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/users/' + uuid).then(
      (response) => {
        dispatch({
          type: FETCH_USER_OBJECT,
          payload: response.data.payload
        })
      }
    )
  }
}

export function fetchUserHash(uuid, pilotId){
  return axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/user-auth/cipher', {
    params: {
      'user-id': uuid,
      'pilot-id': pilotId
    }
  }).then(
    (response) => {
      return response.data.payload;
    }
  )
}

export function fetchUserIdentityData(userHash,options) {
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/user-auth/' + userHash , {
      params : options,
      handlerEnabled : false
    }).then(
      (response) => {
        setAuthToken(response.data.payload.tokenDetails.access_token);
        dispatch(fetchUserInformation(response.data.payload.userCipherDetails.userId)).then(() => {
          dispatch({
            type: FETCH_USER_IDENTITY_DATA,
            payload: response.data.payload
          });
        });
      },
      (error) => {
          dispatch({
            type: USER_HASH_EXPIRED
          });
      }
    )
  }
}
